module.exports = __webpack_public_path__ + "img/direct-debit.42dd0a16.svg";